import styled from "styled-components"

const Overlay = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 45%;
  background: linear-gradient(rgba(247, 248, 250, 0), rgba(247, 248, 250, 95%) 100%);
`

export default Overlay
